// src/auth/keycloak.js
import Keycloak from "keycloak-js";

export function createKeycloakClient({ url, realm, clientId }) {
  return new Keycloak({ url, realm, clientId });
}